import React, { useEffect, Suspense } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import NotFound from '../components/NotFound';
import Welcome from '../components/Welcome/Welcome';
import ScrollToTop from './ScrollToTop';
import { UserPortalContext } from '../context/appcontext';
import ErrorBoundary from '../components/ErrorBoundary';
import analytics from './../helper/analytics';
import Home from '../components/Welcome/Home';
import { LuminateLoader as ProgressLoader } from '@walmart-dataventures/shared-components';
import { useDispatch, useSelector } from 'react-redux';
import { Header as LuminateHeader } from '@walmart-dataventures/integrated-components';
import TabbedLayout from '../components/Layouts/TabbedLayout';
import BreadcrumbLayout from '../components/Layouts/BreadcrumbLayout';
import { getBusinessHierarchy } from '../redux/actions/fullCompanyViewAction';
import { getColumnList } from '../redux/actions/customTableColumnAction';
import { getDataRefreshTimestamp } from '../redux/actions/salesActions';

const CPRoutes = () => {
	const portalUserContext = React.useContext(UserPortalContext);

	const dispatch = useDispatch();

	useEffect(() => {
		if (portalUserContext && Object.keys(portalUserContext).length > 0) {
			analytics.trackLoggedInUserInfo(portalUserContext?.result);
		}
	}, [portalUserContext]);

	const selectedView = useSelector(
		(state) => state.appGuideReducer.selectedView
	);

	const getMetrics = async () => {
		dispatch(
			getColumnList({
				portalUserContext: portalUserContext,
			})
		);
	};

	const getDataRefresh = async () => {
		dispatch(
			getDataRefreshTimestamp({
				portalUserContext: portalUserContext,
			})
		);
	};

	useEffect(() => {
		getDataRefresh();
	}, []);

	useEffect(() => {
		dispatch(getBusinessHierarchy({ portalUserContext }));
		getMetrics();
	}, [selectedView]);

	return (
		<ErrorBoundary>
			<BrowserRouter basename="channelperformance">
				<ScrollToTop />

				<LuminateHeader
					title="Channel Performance"
					showLogo
					basePathDefined
					logoLabel="Channel Performance"
					onSubMenuChange={'ChildApp'}
				/>

				<Suspense fallback={<ProgressLoader showImage />}>
					<Switch>
						<Route path="/" exact component={Home}></Route>
						<Route path="/welcome" exact component={Welcome}></Route>
						<Route path="/dashboard" component={TabbedLayout}></Route>
						<Route path="/details" component={BreadcrumbLayout}></Route>
						<Route component={NotFound} />
					</Switch>
				</Suspense>
			</BrowserRouter>
		</ErrorBoundary>
	);
};

export default CPRoutes;
